import successAccept from 'assets/img/icons/success-green-big.svg'
import successCounter from 'assets/img/icons/confirm-email.svg'
import successDecline from 'assets/img/icons/icon-warning.svg'
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton'
import useEffectOnce from 'hooks/useEffectOnce'
import { useNotificationsRequest } from 'hooks/useNotificationsRequest'

const ReceivedOfferSuccess = ({ type, closeWindow }) => {

  const {fetchNotifications} = useNotificationsRequest();

  useEffectOnce(() => {
    fetchNotifications()
  })

  const getData = () => {
    if (type.includes('accept')) {
      return {
        icon: successAccept,
        title: 'Acceptance sent to the Buyer!'
      }
    } else if (type.includes('counter')) {
      return {
        icon: successCounter,
        title: 'Your counter offer was sent to the buyer!'
      }
    } else if (type.includes('decline')) {
      return {
        icon: successDecline,
        title: 'Buyers offer declined!'
      }
    }
  }

  return (
    <div className="modal-window__wrapper" onClick={(e) => e.stopPropagation()}>
      <PagePopopCloseButton close={closeWindow} />
      <header className="modal-window__header">
        <img src={getData().icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">{getData().title}</h5>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={closeWindow}>Done</button>
      </footer>
    </div>
  )
}

export default ReceivedOfferSuccess;
